// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3hJKI","detailsBorder":"styles_detailsBorder__3V3wO"};